<template>
    <base-select-filter
        v-if="options.length"

        :value="value"
        v-bind="$attrs"
        :options="options"

        option-value="id"
        :option-label="getOptionLabel"
        @input="inputValue => $emit('input', inputValue)"
    >
        <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </base-select-filter>
</template>

<script>
import BaseSelectFilter from '@/components/form/BaseSelectFilter'
import { IGB2BSectorCodeService } from '@/services'

export default {
    name: 'IGB2BSectorCodeSelect',
    components: {
        BaseSelectFilter,
    },
    inheritAttrs: false,
    props: {
        value: {
            required: true,
        },
        filter: {
            type: Object,
        },
    },
    data () {
        return {
            options: [],
        }
    },
    created () {
        const variables = {}
        if (this.filter) Object.assign(variables, this.filter)

        IGB2BSectorCodeService.all(variables).then(response => {
            this.options = response.data
        })
    },
    methods: {
        getOptionLabel (item) {
            return `${item.code} – ${item.name}`
        },
    },
}
</script>
